module.exports = __webpack_public_path__ + "img/P30920580Zcamera.3728c9ef.jpg";